import { render } from "./nav-header.vue?vue&type=template&id=1f3dad10&scoped=true&ts=true"
import script from "./nav-header.vue?vue&type=script&lang=ts"
export * from "./nav-header.vue?vue&type=script&lang=ts"

import "./nav-header.vue?vue&type=style&index=0&id=1f3dad10&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3dad10"]])

export default __exports__